var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{staticClass:"mb-3",attrs:{"outlined":"","dense":"","label":"Delay (in seconds)","hide-details":"auto","type":"number","value":_vm.selectedNode.settings.delay},on:{"input":(val) => _vm.onUpdate(val, 'settings.delay')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }